import { preventBubblingEvent } from '@mote/helpers/browser'
import { Block } from '@mote/ui'
import React from 'react'
import styled, { css } from 'styled-components'
import {
  Durations,
  PlayPauseButton,
  RewindButton,
  ScrubberRich,
  VolumeRich
} from '../../shared/components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'
import { MoteCardRichFloatingDuration } from './MoteCardRichFloatingDuration'
import { MoteCardRichPlaybackRateControl } from './MoteCardRichPlaybackRateControl'

export const MoteCardRichControls = () => {
  const {
    play,
    pause,
    playing,
    paused: isPaused,
    onRewind,
    playerDimensions
  } = useMotePlayer()
  const playbackRateFinalFocusRef = React.useRef(null)

  return (
    <Root
      className='mote-card-controls-root'
      isPaused={isPaused}
      onClick={event => preventBubblingEvent(event)}
    >
      <FloatingDurationContainer
        className='floating-duration-container'
        isPaused={isPaused}
      >
        <MoteCardRichFloatingDuration type='countdown' />
      </FloatingDurationContainer>
      <ScrubberRich />
      <ControlsContainer className='mote-card-controls-container'>
        <LeftSideControls layout='horizontal'>
          <PlayPauseButton
            ref={playbackRateFinalFocusRef}
            isPlaying={playing}
            isReactive={false}
            variant='rich'
            tooltipProps={{ distance: 10 }}
            onClick={isPaused ? play : pause}
          />
          {playerDimensions?.width > 290 && (
            <RewindButton
              size={36}
              variant='rich'
              aria-label='Rewind (5 seconds)'
              tooltipProps={{ content: 'Back 5sec (j)', distance: 10 }}
              onClick={() => onRewind()}
            />
          )}
          <MoteCardRichPlaybackRateControl
            finalFocusRef={playbackRateFinalFocusRef}
          />

          <VolumeRich />
        </LeftSideControls>
        <RightSideControls>
          <Durations
            divider='/'
            fontSize={15}
            color='#ffffff'
            variant={
              playerDimensions?.width > 290 ? 'full' : 'compact-remaining'
            }
          />
        </RightSideControls>
      </ControlsContainer>
    </Root>
  )
}

const Root = styled.div`
  position: absolute;
  bottom: 0;
  min-height: 50px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transform: translateY(44px);
  transition: transform 150ms ease-out 2s;
  z-index: 3;

  ${({ isPaused }) =>
    isPaused &&
    css`
      transform: translateY(0);
    `};
`

const ControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  background: rgba(33, 34, 40, 0.4);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 0 8px;

  svg {
    cursor: pointer;
  }
`

const LeftSideControls = styled(Block)``
const RightSideControls = styled.div``

const FloatingDurationContainer = styled.div`
  position: relative;
  opacity: 1;
  transition: opacity 150ms ease-out 2s;

  ${({ isPaused }) =>
    isPaused &&
    css`
      opacity: 0;
    `};
`
